import React from 'react';

/**
 * Partner brand mark — shows the partner's uploaded logo, or a colored
 * initials avatar (1-2 characters) when no logo is available.
 * Colour is hash-derived from the partner name so every partner gets
 * a consistent, unique shade across sessions.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PALETTE = [
  { bg: 'bg-amber-500', text: 'text-slate-900' },
  { bg: 'bg-sky-500', text: 'text-white' },
  { bg: 'bg-emerald-500', text: 'text-white' },
  { bg: 'bg-rose-500', text: 'text-white' },
  { bg: 'bg-violet-500', text: 'text-white' },
  { bg: 'bg-teal-500', text: 'text-white' },
  { bg: 'bg-indigo-500', text: 'text-white' },
  { bg: 'bg-pink-500', text: 'text-white' },
  { bg: 'bg-orange-500', text: 'text-slate-900' },
  { bg: 'bg-cyan-500', text: 'text-slate-900' },
];

const sizeMap = {
  sm: 'w-8 h-8 text-sm',
  md: 'w-10 h-10 text-base',
  lg: 'w-12 h-12 text-lg',
  xl: 'w-20 h-20 text-3xl',
};

const hashString = (str) => {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h);
};

const getInitials = (name) => {
  if (!name) return 'WK';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return 'WK';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const PartnerMark = ({
  partnerInfo,
  size = 'md',
  showName = true,
  nameClassName = '',
  className = '',
}) => {
  const name = partnerInfo?.partner_name || partnerInfo?.name || '';
  const rawLogo = partnerInfo?.logo || partnerInfo?.logo_url;
  const logo = rawLogo
    ? (rawLogo.startsWith('http') ? rawLogo : `${BACKEND_URL}${rawLogo}`)
    : null;
  const boxCls = sizeMap[size] || sizeMap.md;
  const palette = PALETTE[hashString(name || 'WK') % PALETTE.length];

  return (
    <span
      className={`inline-flex items-center gap-2 min-w-0 ${className}`}
      data-testid="partner-mark"
    >
      {logo ? (
        <img
          src={logo}
          alt={name || 'Partner'}
          className={`${boxCls} rounded-lg object-contain bg-slate-800 flex-shrink-0`}
        />
      ) : (
        <span
          className={`${boxCls} rounded-lg ${palette.bg} ${palette.text} font-bold flex items-center justify-center flex-shrink-0 shadow-md`}
          aria-hidden="true"
        >
          {getInitials(name)}
        </span>
      )}
      {showName && (
        <span
          className={`font-semibold text-white truncate min-w-0 ${nameClassName}`}
          title={name}
        >
          {name || 'WillKart'}
        </span>
      )}
    </span>
  );
};

export { getInitials };
export default PartnerMark;
